(() => {
  'use strict';


  /* =========================================================
     Prevent duplicate initialization
  ========================================================== */

  if (window.__setlaroServiceInfoLoaded) {

    if (
      typeof window.SetlaroServiceInfoInit === 'function'
    ) {
      window.SetlaroServiceInfoInit(document);
    }

    return;
  }


  window.__setlaroServiceInfoLoaded = true;



  /* =========================================================
     Add calendar / business days
  ========================================================== */

  function addDays(startDate, numberOfDays, dayType) {

    const date =
      new Date(startDate.getTime());


    const days =
      Math.max(
        0,
        parseInt(numberOfDays, 10) || 0
      );


    /*
     * Calendar days:
     * Saturday / Sunday are counted normally.
     */

    if (dayType !== 'business') {

      date.setDate(
        date.getDate() + days
      );

      return date;
    }


    /*
     * Business days:
     * Skip Saturday and Sunday.
     */

    let remaining = days;


    while (remaining > 0) {

      date.setDate(
        date.getDate() + 1
      );


      const weekday =
        date.getDay();


      if (
        weekday !== 0 &&
        weekday !== 6
      ) {
        remaining -= 1;
      }

    }


    return date;
  }



  /* =========================================================
     Format delivery range
  ========================================================== */

  function formatDateRange(startDate, endDate, locale) {

    const startMonth =
      new Intl.DateTimeFormat(
        locale,
        { month: 'short' }
      ).format(startDate);


    const endMonth =
      new Intl.DateTimeFormat(
        locale,
        { month: 'short' }
      ).format(endDate);


    const startDay =
      startDate.getDate();


    const endDay =
      endDate.getDate();


    const startYear =
      startDate.getFullYear();


    const endYear =
      endDate.getFullYear();


    const sameMonth =
      startDate.getMonth() ===
      endDate.getMonth();


    const sameYear =
      startYear === endYear;


    /*
     * Example:
     * Aug 17–25
     */

    if (
      sameMonth &&
      sameYear
    ) {

      if (startDay === endDay) {
        return `${startMonth} ${startDay}`;
      }


      return (
        `${startMonth} ` +
        `${startDay}–${endDay}`
      );
    }


    /*
     * Example:
     * Aug 28 – Sep 6
     */

    if (sameYear) {

      return (
        `${startMonth} ${startDay}` +
        ` – ` +
        `${endMonth} ${endDay}`
      );
    }


    /*
     * Example:
     * Dec 28, 2026 – Jan 5, 2027
     */

    return (
      `${startMonth} ${startDay}, ${startYear}` +
      ` – ` +
      `${endMonth} ${endDay}, ${endYear}`
    );
  }



  /* =========================================================
     Initialize one service block
  ========================================================== */

  function initServiceBlock(container) {

    if (!container) {
      return;
    }


    const output =
      container.querySelector(
        '[data-setlaro-delivery-date]'
      );


    if (!output) {
      return;
    }


    let minDays =
      parseInt(
        container.dataset.minDays,
        10
      );


    let maxDays =
      parseInt(
        container.dataset.maxDays,
        10
      );


    if (!Number.isFinite(minDays)) {
      minDays = 7;
    }


    if (!Number.isFinite(maxDays)) {
      maxDays = 15;
    }


    /*
     * If the merchant accidentally enters:
     *
     * Min = 15
     * Max = 7
     *
     * automatically correct the order.
     */

    const earliestDays =
      Math.min(
        minDays,
        maxDays
      );


    const latestDays =
      Math.max(
        minDays,
        maxDays
      );


    const dayType =
      container.dataset.dayType === 'business'
        ? 'business'
        : 'calendar';


    const prefix =
      (
        container.dataset.deliveryPrefix ||
        ''
      ).trim();


    /*
     * Use customer's local date.
     *
     * Noon is used instead of midnight to reduce
     * DST / timezone edge cases.
     */

    const today =
      new Date();


    today.setHours(
      12,
      0,
      0,
      0
    );


    const earliestDate =
      addDays(
        today,
        earliestDays,
        dayType
      );


    const latestDate =
      addDays(
        today,
        latestDays,
        dayType
      );


    const locale =
      document.documentElement.lang ||
      'en-US';


    const range =
      formatDateRange(
        earliestDate,
        latestDate,
        locale
      );


    output.textContent =
      prefix
        ? `${prefix} ${range}`
        : range;
  }



  /* =========================================================
     Initialize all blocks
  ========================================================== */

  function initAll(root = document) {

    const blocks = [];


    if (
      root instanceof Element &&
      root.matches(
        '[data-setlaro-service-info]'
      )
    ) {
      blocks.push(root);
    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          '[data-setlaro-service-info]'
        )
        .forEach(block => {

          if (!blocks.includes(block)) {
            blocks.push(block);
          }

        });

    }


    blocks.forEach(
      initServiceBlock
    );
  }



  /* =========================================================
     Initial page load
  ========================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(document),
      { once: true }
    );

  } else {

    initAll(document);

  }



  /* =========================================================
     Shopify Theme Editor support
  ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {
      initAll(event.target);
    }
  );


  document.addEventListener(
    'shopify:block:select',
    event => {

      const section =
        event.target.closest(
          '.shopify-section'
        );

      initAll(
        section || document
      );

    }
  );



  /* =========================================================
     Recalculate if visitor keeps page open overnight
  ========================================================== */

  document.addEventListener(
    'visibilitychange',
    () => {

      if (!document.hidden) {
        initAll(document);
      }

    }
  );



  /* =========================================================
     Small public API for debugging
  ========================================================== */

  window.SetlaroServiceInfoInit =
    initAll;

})();